import { AxiosInstance } from 'axios';
import { ModalHook } from '../../../../services/hooks/useModal';

async function deletarInsumo(
  store: any,
  state: any,
  modalExclusao: ModalHook,
  sync: Function,
  api: AxiosInstance,
): Promise<void> {
  const compra = store.insumos!.get(state.selectedInsumo);
  modalExclusao.close();
  store.toggleLoader();

 
    await api
      .delete('/produto/' + compra.id + '/?prop=' + store.propriedade.id)
      .then(() => {
        store.notificar('Insumo excluído com sucesso!');
      })
      .catch((e) => store.notificar(e.response.data.erro));
  
  await sync(state);
  store.toggleLoader();
}

export default deletarInsumo;
